"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deriveSumTerpenes = exports.deriveSumCannabinoids = exports.deriveTotalCannabinoids = exports.deriveTotalTHC = exports.deriveSpecificTHC = exports.deriveTotalCBD = exports.correctForDensity = exports.correctForMoisture = exports.convertPpmToPercent = exports.calculateTotalCBD = exports.calculateTotalTHC = void 0;
var _1 = require(".");
var R = __importStar(require("ramda"));
var function_1 = require("fp-ts/lib/function");
var cards_1 = require("../components/cards");
var DECARB_FACTOR = 0.877;
var calculateDecarboxylatedValue = function (value) { return DECARB_FACTOR * value; };
var calculateTotalTHC = function (THCA, d9THC) {
    return calculateDecarboxylatedValue(THCA) + d9THC;
};
exports.calculateTotalTHC = calculateTotalTHC;
var calculateTotalCBD = function (CBDA, CBD) {
    return calculateDecarboxylatedValue(CBDA) + CBD;
};
exports.calculateTotalCBD = calculateTotalCBD;
var convertPpmToPercent = function (value) { return value / 10000; };
exports.convertPpmToPercent = convertPpmToPercent;
exports.correctForMoisture = R.curry(function (componentValue, moisturePercentage) {
    if (moisturePercentage === void 0) { moisturePercentage = 0; }
    return componentValue / (1 - moisturePercentage / 100);
});
exports.correctForDensity = R.curry(function (componentValue, density) {
    if (density === void 0) { density = 1; }
    return componentValue * density;
});
var adjustCannabinoidValue = function (_a) {
    var parameters = _a.parameters, componentRawName = _a.componentRawName;
    return function (value) {
        var _a;
        var loq = (_a = parameters.find(function (_a) {
            var rawName = _a.referenceComponent.rawName;
            return componentRawName === rawName;
        })) === null || _a === void 0 ? void 0 : _a.levelOfQuantitation;
        if (!!loq && value < loq) {
            return 0;
        }
        return value;
    };
};
var deriveTotalCBD = function (result, moistureContentPercentage, density, parameters) {
    if (moistureContentPercentage === void 0) { moistureContentPercentage = 0; }
    if (density === void 0) { density = 1; }
    if (parameters === void 0) { parameters = []; }
    if (!result)
        return 0;
    if (R.compose(R.not, cards_1.areAnySubAnalytesAboveLOD({
        analyteKey: "name",
        subAnalytes: ["CBDA", "CBD"],
    }))({ parameters: parameters, components: result.results.components })) {
        return "ND";
    }
    if (R.compose(R.not, cards_1.areAnySubAnalytesAboveLOQ({
        analyteKey: "name",
        subAnalytes: ["CBDA", "CBD"],
    }))({ parameters: parameters, components: result.results.components })) {
        return "<LOQ";
    }
    return exports.calculateTotalCBD(function_1.pipe(result.results.components, _1.findAnalyteResults({ rawName: "CBDA" }), R.prop("final_amount"), adjustCannabinoidValue({ parameters: parameters, componentRawName: "CBDA" }), exports.correctForDensity(R.__, density), exports.correctForMoisture(R.__, moistureContentPercentage)), function_1.pipe(result.results.components, _1.findAnalyteResults({ rawName: "CBD" }), R.prop("final_amount"), adjustCannabinoidValue({ parameters: parameters, componentRawName: "CBD" }), exports.correctForDensity(R.__, density), exports.correctForMoisture(R.__, moistureContentPercentage)));
};
exports.deriveTotalCBD = deriveTotalCBD;
var deriveSpecificTHC = function (analyte, result, moistureContentPercentage, density, parameters) {
    if (moistureContentPercentage === void 0) { moistureContentPercentage = 0; }
    if (density === void 0) { density = 1; }
    if (parameters === void 0) { parameters = []; }
    if (!result)
        return 0;
    if (R.compose(R.not, cards_1.areAnySubAnalytesAboveLOD({
        analyteKey: "name",
        subAnalytes: [analyte],
    }))({ parameters: parameters, components: result.results.components })) {
        return "ND";
    }
    if (R.compose(R.not, cards_1.areAnySubAnalytesAboveLOQ({
        analyteKey: "name",
        subAnalytes: [analyte],
    }))({ parameters: parameters, components: result.results.components })) {
        return "<LOQ";
    }
    return exports.correctForMoisture(exports.correctForDensity(R.prop("final_amount", _1.findAnalyteResults({ rawName: analyte })(result.results.components)), density), moistureContentPercentage);
};
exports.deriveSpecificTHC = deriveSpecificTHC;
var deriveTotalTHC = function (result, moistureContentPercentage, density, parameters) {
    if (moistureContentPercentage === void 0) { moistureContentPercentage = 0; }
    if (density === void 0) { density = 1; }
    if (parameters === void 0) { parameters = []; }
    if (!result)
        return 0;
    if (R.compose(R.not, cards_1.areAnySubAnalytesAboveLOD({
        analyteKey: "name",
        subAnalytes: ["THCA", "d9-THC"],
    }))({ parameters: parameters, components: result.results.components })) {
        return "ND";
    }
    if (R.compose(R.not, cards_1.areAnySubAnalytesAboveLOQ({
        analyteKey: "name",
        subAnalytes: ["THCA", "d9-THC"],
    }))({ parameters: parameters, components: result.results.components })) {
        return "<LOQ";
    }
    return exports.calculateTotalTHC(function_1.pipe(result.results.components, _1.findAnalyteResults({ rawName: "THCA" }), R.prop("final_amount"), exports.correctForDensity(R.__, density), exports.correctForMoisture(R.__, moistureContentPercentage)), function_1.pipe(result.results.components, _1.findAnalyteResults({ rawName: "d9-THC" }), R.prop("final_amount"), exports.correctForDensity(R.__, density), exports.correctForMoisture(R.__, moistureContentPercentage)));
};
exports.deriveTotalTHC = deriveTotalTHC;
var deriveTotalCannabinoids = function (result, moistureContentPercentage, density, parameters) {
    if (moistureContentPercentage === void 0) { moistureContentPercentage = 0; }
    if (density === void 0) { density = 1; }
    if (parameters === void 0) { parameters = []; }
    if (!result)
        return 0;
    if (R.compose(R.not, cards_1.areAnySubAnalytesAboveLOD({
        analyteKey: "name",
        subAnalytes: result.results.components.map(R.prop("name")),
    }))({ parameters: parameters, components: result.results.components })) {
        return "ND";
    }
    if (R.compose(R.not, cards_1.areAnySubAnalytesAboveLOQ({
        analyteKey: "name",
        subAnalytes: result.results.components.map(R.prop("name")),
    }))({ parameters: parameters, components: result.results.components })) {
        return "<LOQ";
    }
    return result.results.components.reduce(function (acc, component) {
        var _a, _b;
        if ((component.final_amount || 0) <
            ((_b = (_a = parameters.find(function (parameter) { return parameter.referenceComponent.rawName === component.name; })) === null || _a === void 0 ? void 0 : _a.levelOfQuantitation) !== null && _b !== void 0 ? _b : 0)) {
            return acc;
        }
        return function_1.pipe(component.final_amount || 0, R.ifElse(function () { return _1.isAcidicCannabinoid(component.name); }, calculateDecarboxylatedValue, R.identity), exports.correctForMoisture(R.__, moistureContentPercentage), exports.correctForDensity(R.__, density), R.add(acc));
    }, 0);
};
exports.deriveTotalCannabinoids = deriveTotalCannabinoids;
var deriveSumCannabinoids = function (result, moistureContentPercentage, density, parameters) {
    if (moistureContentPercentage === void 0) { moistureContentPercentage = 0; }
    if (density === void 0) { density = 1; }
    if (parameters === void 0) { parameters = []; }
    if (!result)
        return 0;
    if (R.compose(R.not, cards_1.areAnySubAnalytesAboveLOD({
        analyteKey: "name",
        subAnalytes: result.results.components.map(R.prop("name")),
    }))({ parameters: parameters, components: result.results.components })) {
        return "ND";
    }
    if (R.compose(R.not, cards_1.areAnySubAnalytesAboveLOQ({
        analyteKey: "name",
        subAnalytes: result.results.components.map(R.prop("name")),
    }))({ parameters: parameters, components: result.results.components })) {
        return "<LOQ";
    }
    return result.results.components.reduce(function (acc, component) {
        return function_1.pipe(component.final_amount || 0, exports.correctForMoisture(R.__, moistureContentPercentage), exports.correctForDensity(R.__, density), R.add(acc));
    }, 0);
};
exports.deriveSumCannabinoids = deriveSumCannabinoids;
var deriveSumTerpenes = function (result) {
    return result
        ? result.results.components.reduce(function (acc, component) { return acc + component.final_amount || 0; }, 0)
        : 0;
};
exports.deriveSumTerpenes = deriveSumTerpenes;
//# sourceMappingURL=calculations.js.map